import { configureStore } from '@reduxjs/toolkit';
import authReducer, { logout } from './authSlice';
import documentsReducer from './documentsSlice';
import questionnaireReducer from './questionnaireSlice';
import analysisReducer from './analysisSlice';
import formsReducer from './formsSlice';
import projectsReducer from './projectsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    documents: documentsReducer,
    questionnaire: questionnaireReducer,
    analysis: analysisReducer,
    forms: formsReducer,
    projects: projectsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export actions
export { logout };

export default store;
